var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"fm-contextual-help",attrs:{"href":_vm.link,"target":"_blank"}},[_c('md-icon',[_vm._v("help")]),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.tooltipText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }